import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { get } from 'lodash';
import { assert } from "./assert";

/**
 * Renders a template by replacing placeholders with corresponding values from the data object.
 *
 * @param template - The template string with placeholders.
 * @param data - The data object containing values for the placeholders.
 * @returns The rendered template string.
 */
function render(template, data) {
  return template.replace(/\{\{\s*(.+?)\s*\}\}/g, function (match, key) {
    var result = get(data, key.trim(), '');
    assert(typeof result === 'string' || typeof result === 'number', "Value for key ".concat(key, " is not a string or number"));
    return result.toString();
  });
}

/**
 * This is a simple version of mustache template rendering.  We can replace this
 * with the actual mustache npm package if needed, but this should be sufficient
 * for now and avoids increasing the bundle size
 */
export var Mustache = {
  render: render
};